exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Alert-module__wrapper___1LGzF{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;padding:1.5rem;min-width:600px;min-height:200px;border-radius:17px;z-index:200;display:grid;justify-items:center;gap:1rem;box-shadow:0 0 17.5px rgba(0,0,0,.08);text-align:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Alert-module__wrapper___1LGzF"
};